export default __webpack_public_path__ + "static/media/banner_pgtos.b16b3098.png";